import { render, staticRenderFns } from "./PcFixedHeaderLayout.vue?vue&type=template&id=ea9e38f2&scoped=true"
import script from "./PcFixedHeaderLayout.vue?vue&type=script&lang=js"
export * from "./PcFixedHeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./PcFixedHeaderLayout.vue?vue&type=style&index=0&id=ea9e38f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9e38f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VWindow } from 'vuetify/lib/components/VWindow';
installComponents(component, {VAppBar,VCol,VContainer,VProgressCircular,VRow,VTab,VTabs,VWindow})
